import { accountApiUrl, userProfileApiUrl } from '../../environment';
import { SET_USER_PREFERENCES } from '../../graphql/mutations/personalDetails/mutations';
import { GET_USER_PROFILE } from '../../graphql/queries/personalDetails/queries';
import { axios, axiosWithAuth } from '../../utilities';
import { APP_SETTINGS } from '../constants';

const baseUrl = `${accountApiUrl}/v1`;

export default class AccountApi {
  static getPersonalDetails() {
    const endpoint = `${baseUrl}/personaldetails`;
    return axiosWithAuth({ timeout: 20000 }).get(endpoint);
  }

  static updateAddress(address: Record<string, unknown>) {
    const endpoint = `${baseUrl}/personaldetails/address`;
    return axiosWithAuth({ timeout: 20000 }).post(endpoint, address);
  }

  static updatePersonalInformation(userPersonalInformation: Record<string, unknown>) {
    const endpoint = `${baseUrl}/personaldetails/personal-information`;
    return axiosWithAuth({ timeout: 20000 }).post(endpoint, userPersonalInformation);
  }

  static getAppSettings() {
    const endpoint = `${baseUrl}/applicationsetting/settings`;
    const queryParams = APP_SETTINGS.map((setting) => `keys=${setting}`).join('&');
    return axios({ timeout: 3000 })
      .get(`${endpoint}?${queryParams}`)
      .then((res) => res.data);
  }

  static getFinancingTerms() {
    const endpoint = `${baseUrl}/finance`;
    return axiosWithAuth().get(endpoint);
  }

  static getFinancingTermsOverview() {
    const endpoint = `${baseUrl}/finance/overview`;
    return axiosWithAuth().get(endpoint);
  }

  static setToggleCoApplicant() {
    const endpoint = `${baseUrl}/finance/toggle-coapplicant`;
    return axiosWithAuth().post(endpoint);
  }

  static getUserProfileData(userId: string) {
    return axiosWithAuth({ timeout: 20000 }).post(
      userProfileApiUrl,
      {
        query: GET_USER_PROFILE,
        variables: { userId }
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'apollographql-client-name': 'account-ui',
          'apollographql-client-version': '1.0'
        }
      }
    );
  }

  static updateUserProfileData(userId: string, preferredName: string, preferredLanguage: string) {
    return axiosWithAuth({ timeout: 20000 }).post(
      userProfileApiUrl,
      {
        query: SET_USER_PREFERENCES,
        variables: {
          userId,
          input: {
            preferredName,
            preferredLanguage
          }
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'apollographql-client-name': 'account-ui',
          'apollographql-client-version': '1.0'
        }
      }
    );
  }
}
